import { useTranslation } from 'react-i18next';
import { SelectedRole } from './types';
import { useEffect, useState } from 'react';
import styles from './index.module.css';
import { useTable } from 'src/hooks/use-table';
import { useRoles } from 'src/hooks/query/permissions/roles/use-roles';
import { Filter } from './filter';
import { RolesTable } from './table';
import { ActionType } from './table/columns/actions';

type AvailableRolesTableProps = {
  selectedItems: SelectedRole[];
  onChange: (item: SelectedRole) => void;
  withLinks?: boolean;
};

const PAGINATION_LIMIT = 5;

export const AvailableRolesTable = ({
  selectedItems,
  onChange,
  withLinks,
}: AvailableRolesTableProps) => {
  const { t } = useTranslation();

  // ToDo: Remove this solution when OTP2-728 is done
  const [records, setRecords] = useState<SelectedRole[]>([]);

  const { page, setPage, filter, onFilterChange } = useTable<
    any,
    Record<any, any>
  >();

  const { roles, totalCount, loading } = useRoles({
    filter: {
      ...filter,
      excludeIds: selectedItems.map((role) => role.id),
    },
    pagination: {
      page,
      limit: PAGINATION_LIMIT,
    },
    onCompleted: (data) => setRecords(data.roles.records || []),
  });

  const onAdd = (id: string) => {
    const selectedRole = roles.find((role) => role.id === id);

    if (!selectedRole) {
      return;
    }

    onChange(selectedRole);
  };

  return (
    <div className="flex-1">
      <Filter
        onSubmit={onFilterChange}
        className={styles.filterWrapper}
        searchInputProps={{
          label: t('roles.form.filter.search.label-to-add'),
        }}
      />

      <RolesTable
        data={records}
        className="mt-4"
        options={{
          page,
          count: totalCount,
          rowsPerPage: PAGINATION_LIMIT,
          onChangePage: setPage,
        }}
        loading={loading}
        onChange={onAdd}
        action={ActionType.Add}
        forceShowingPagination
        withLinks={withLinks}
      />
    </div>
  );
};
